(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDocumentosDossierNewController", LebaniegoYearDocumentosDossierNewController);

        LebaniegoYearDocumentosDossierNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearDocumentosDossier",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearDocumentosDossierNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearDocumentosDossier,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosDossier = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosDossier = Object.assign({}, vm.lebaniegoYearDocumentosDossier);
            lebaniegoYearDocumentosDossier.id = null;
            LebaniegoYearDocumentosDossier.save(lebaniegoYearDocumentosDossier, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-documents-dossier", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el dossier");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();